import { ButtonGroup as PrimerButtonGroup, ButtonGroupProps as PrimerButtonGroupProps } from '@primer/react';

type Props = {} & PrimerButtonGroupProps;

const ButtonGroup = ({ ...props }: Props) => <PrimerButtonGroup {...props} />;

export default ButtonGroup;
export type { Props as ButtonGroupProps };
